export const DEFAULT_EXEC_FILTERS = { portfolio: "", program: "", pm: "", sort: "risk" };

export const SORTS = [
  { v: "risk", l: "Risk (high → low)", s: "Risk" },
  { v: "due", l: "Due date (soonest)", s: "Due date" },
  { v: "name", l: "Name (A → Z)", s: "Name" },
];

const byRisk = (a, b) => (b.risk_score || 0) - (a.risk_score || 0);
const byDue = (a, b) => (a.stated_due_date || "9999").localeCompare(b.stated_due_date || "9999");
const byName = (a, b) => (a.name || "").localeCompare(b.name || "");
const SORT_FN = { risk: byRisk, due: byDue, name: byName };

export function applyExecFilters(data, portfolios, f) {
  const pf = portfolios.find((p) => p.id === f.portfolio);
  const pfPrograms = pf ? new Set(pf.selected_programs || []) : null;
  const projects = data.projects
    .filter((p) => !pfPrograms || pfPrograms.has(p.program_id))
    .filter((p) => !f.program || p.program_id === f.program)
    .filter((p) => !f.pm || (f.pm === "_unassigned" ? !p.pm_teammate_id : p.pm_teammate_id === f.pm))
    .sort((a, b) => (a.is_open === b.is_open ? (SORT_FN[f.sort] || byRisk)(a, b) : a.is_open ? -1 : 1));

  const perPm = {};
  projects.forEach((r) => {
    const k = r.pm_teammate_id || "_unassigned";
    const e = (perPm[k] ||= { pm_teammate_id: r.pm_teammate_id, pm_name: r.pm_name || "Unassigned", project_count: 0, open_count: 0 });
    e.project_count += 1;
    if (r.is_open) e.open_count += 1;
  });
  const programCount = f.program ? 1 : pfPrograms ? pfPrograms.size : data.program_count;
  return {
    projects,
    perPm: Object.values(perPm).sort((a, b) => (a.pm_teammate_id ? 0 : 1) - (b.pm_teammate_id ? 0 : 1) || b.project_count - a.project_count),
    counts: {
      portfolio_count: pf ? 1 : data.portfolio_count,
      program_count: programCount,
      project_count: projects.length,
      open_project_count: projects.filter((p) => p.is_open).length,
      pm_count: Object.keys(perPm).filter((k) => k !== "_unassigned").length,
    },
  };
}

export function describeFilters(f, { portfolios, programs, pms }) {
  const parts = [];
  if (f.portfolio) parts.push(`Portfolio: ${portfolios.find((p) => p.id === f.portfolio)?.name || "—"}`);
  if (f.program) parts.push(`Program: ${programs.find((p) => p.id === f.program)?.name || "—"}`);
  if (f.pm) parts.push(`PM: ${f.pm === "_unassigned" ? "Unassigned" : pms.find((p) => p.id === f.pm)?.name || "—"}`);
  parts.push(`Sorted by ${SORTS.find((s) => s.v === f.sort)?.s || "Risk"}`);
  return parts.length === 1 ? `All projects · ${parts[0]}` : parts.join(" · ");
}
